<template lang="pug">
	.schedule-editor-insturciton-line-creative.schedule-cell(:class="{ removing: this.isRemoving }")
		.swing-in-top-fwd.schedule-cell.creative-item.flex-row.align-center.space
			.flex-row.actions(v-if="!readonly", @click="removeCreative")
				i.fas.fa-trash
			.flex-col
				.font-small.upper.grey {{$tCaption('Creative')}}
				Dropdown(ref="creativeSelector",
					:disabled="readonly"
					v-model="item.CreativeId",
					:multiple="false",
					:getData="getCreatives",
					:getItems="r => r.Results",
					:filtersVisible="false",
					:columns="[{ dataField: 'Name', caption: 'Name' }, { dataField: 'Length', caption: 'Length (sec)' }, { dataField: 'ISCI', caption: 'ISCI' }]",
					:placeholder="$tCaption('Creative')",
					valueExpr="Oid",
					displayExpr="Name")
			.flex-col
				.font-small.upper.grey {{$tCaption('Weight')}}
				DxNumberBox(:value.sync="item.Weight", :width="80", :disabled="readonly")
</template>

<script>
	import Data from 'app-core/Data';
	import DxTagBox from 'devextreme-vue/tag-box';
	import DxDateBox from 'devextreme-vue/date-box';
	import DxTextBox from 'devextreme-vue/text-box';
	import DxSelectBox from 'devextreme-vue/select-box';
	import { DxNumberBox } from 'devextreme-vue/number-box';
	import Dropdown from 'app-core/Dropdown.vue';

	export default {
		translationCategory: 'schedule.ScheduleEditorInstructionLineCreative',
		name: 'schedule-editor-insturciton-line-creative',
		components: {
			DxTagBox, DxDateBox, DxTextBox, DxSelectBox, DxNumberBox, Dropdown
		},
		props: ['item', 'itemIndex', 'campaignId', 'readonly'],
		data() {
			return {
				isRemoving: false
			};
		},
		computed: {
			hasCreative() {
				return !!this.item.CreativeId;
			}
		},
		watch: {
			'item.CreativeId'(v) {
				if (v) {
					this.saveCreative();
				}
			},
			'item.Weight'() {
				this.saveCreative();
			}
		},
		mounted() {
		},
		methods: {
			getCreatives(pageIndex, limit, opts) {
				return this.$Data.getExternalCampaignCreatives(pageIndex, limit, opts, this.campaignId);
			},
			saveCreative() {
				if (__DEBUG__)
					console.debug('Saving creative', { creative: this.item });
				Data.postExternalApi('Instruction/AddUpdateCreativesToInstructionLine', [this.item]).then(r => {
					if (__DEBUG__)
						console.log('AddUpdateCreativesToInstructionLine', { r });
				});
			},
			removeCreative() {
				if (!this.hasCreative) {
					this.$emit('remove', this.item, this.itemIndex);
				} else {
					this.isRemoving = true;
					Data.getExternalApi('Instruction/RemoveCreativesFromInstructionLine', `instructionLineId=${this.item.InstructionLineId}&creativeIds=${this.item.CreativeId}`).then(r => {
						if (__DEBUG__)
							console.log('RemoveCreativesFromInstructionLine', { r });
						if (r.Success)
							this.$emit('remove', this.item, this.itemIndex);
					}).finally(() => this.isRemoving = false);
				}
			}
		}
	};
</script>
<style lang='scss'>
	.schedule-editor-insturciton-line-creative {
		@import "main/themes/generated/variables.base.scss";

	}
</style>
